<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>检查报告</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="submitFn"
          >生成检查报告</el-button
        >
      </div>
      <!-- card header -->
      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="110px"
        ref="formData"
      >
        <el-row>
          <el-col :span="11">
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="formData.title"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="11">
            <el-form-item label="年度" prop="annual">
              <el-select v-model="formData.annual" placeholder="请选择年度">
                <el-option
                  v-for="item in annualList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- <el-date-picker
                v-model="formData.annual"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择发布日期"
              ></el-date-picker> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="所属项目" prop="projectId">
              <el-select
                v-model="formData.projectId"
                placeholder="请选择"
                @change="proChange"
                clearable
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="11" v-if="formData.projectId">
            <el-form-item label="所属合同" prop="contractId">
              <el-select
                v-model="formData.contractId"
                placeholder="请先选择项目"
                @change="conChange"
                clearable
              >
                <el-option
                  v-for="item in contractList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            v-for="(item, index) in formData.roundsList"
            :label="'轮次' + (index + 1)"
            style="display: flex"
            :key="index"
            required
          >
            <el-col style="display: flex">
              <el-form-item
                label="开始时间"
                :prop="`roundsList[${index}].checkTime`"
                :rules="rules.checkTime"
                :key="index"
              >
                <el-date-picker
                  v-model="item.checkTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择开始时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                label="截止时间"
                :prop="`roundsList[${index}].deadline`"
                :rules="rules.deadline"
              >
                <el-date-picker
                  v-model="item.deadline"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择截止时间"
                >
                </el-date-picker>
              </el-form-item>
              <div style="margin-left: 20px">
                <el-form-item
                  style="display: inline-block"
                  v-if="formData.roundsList.length > 1"
                >
                  <el-button
                    icon="el-icon-delete"
                    @click="deleteFn(index)"
                  ></el-button>
                </el-form-item>
                <el-form-item
                  style="display: inline-block; margin-left: 10px"
                  v-if="index === Number(formData.roundsList.length) - 1"
                >
                  <el-button icon="el-icon-plus" @click="addFn"></el-button>
                </el-form-item>
              </div>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <div v-if="chartList.length > 0">
        <div style="color: red">
          请选择报告需要的图表（图表左上角框选中默认全选）
        </div>

        <div class="boxList">
          <div v-for="(item, index) in chartList" :key="index" class="date-box">
            <div
              class="data-chartline data-lang-box"
              v-if="item.type == 'lineBar'"
            >
              <el-checkbox v-model="item.checked"> </el-checkbox>

              <!-- <ChartsmixBar
                :title="item.title"
                :data="item.hashMap"
                :key="index + 'j'"
                :ref="'chart' + item.chartId"
              /> -->
              <StackedColumnPie
                :title="item.title"
                :data="item.hashMap"
                :key="index + 'j'"
                :ref="'chart' + item.chartId"
              />
            </div>
            <div class="data-chart data-lang-box" v-if="item.type == 'sortBar'">
              <el-checkbox v-model="item.checked"> </el-checkbox>
              <StackedColumn
                :title="item.title"
                :data="item.hashMap"
                :key="index + 'i'"
                :ref="'chart' + item.chartId"
              ></StackedColumn>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 40px">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>检测报告</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="checkReportFn"
          >生成检测报告</el-button
        >
      </div>
      <el-form
        :model="formCheck"
        :rules="rulesCheck"
        label-width="110px"
        ref="formCheck"
      >
        <el-row>
          <el-col :span="11">
            <el-form-item label="检测年份" prop="year">
              <el-select
                style="width: 120px"
                v-model="formCheck.year"
                placeholder="请选择年份"
                clearable
                @change="queryScoreByYearFn"
              >
                <el-option
                  v-for="item in yearsList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="11">
            <el-form-item label="所在区域" prop="area">
              <el-cascader
                :options="areaSelectData"
                @change="handleChange"
                class="full-width"
                size="large"
                v-model="formCheck.selectedOptions"
                placeholder="请选择区域"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {
  uploadFile,
  getProjecitList,
  getContractList,
  queryScoreByLevelThird,
  genReports,
  genCheckReports,
  dangerousDeviceByType,
  findTime,
  findApplyStatus
} from '@/api/inspectReport'
import StackedColumnPie from './components/StackedColumnPie'
import StackedColumn from './components/StackedColumn'
import { saveAs } from 'file-saver'
import { regionDataPlus, CodeToText } from 'element-china-area-data'
export default {
  components: {
    // ChartstoperrBar,
    StackedColumnPie,
    StackedColumn
  },
  data() {
    return {
      isProject: true,
      requestStatus: false,
      requestCheckStatus: false,
      // areaSelectData: pcaTextArr, //省市区三级联动数据

      areaSelectData: regionDataPlus, //省市区三级联动数据
      addr: null,
      yearsListL: [], //年份
      chartList: [
        // {
        //   type: 'bar',
        //   title: '各机型设备得分及危险设备占比情况',
        //   checked: false,
        //   list: {}
        // },
        // {
        //   type: 'sortBar',
        //   title: '电梯安全隐患频次图',
        //   checked: false,
        //   list: []
        // },
        // {
        //   type: 'sortBar',
        //   title: '电梯安全隐患频次图',
        //   checked: false,
        //   list: []
        // },
        // {
        //   type: 'sortBar',
        //   title: '电梯安全隐患频次图',
        //   checked: false,
        //   list: []
        // }
      ],
      // title2: '电梯安全隐患频次图',
      // title3: '电梯安全隐患频次图',
      // title4: '电梯安全隐患频次图',
      //       topCheckRateList1: [],

      // },
      createDate: '', //合同开始时间
      submitTime: '', //合同结束时间
      // 表单配置
      formData: {
        projectId: '',
        contractId: '',
        annual: '',
        title: '',
        pictureEntityList: [], //选择的图表，横向柱状排序图
        pictureEntityListFirst: [], //选择的图表，柱状图
        roundsList: [
          {
            checkTime: '', //开始时间
            name: '', //第几轮次
            deadline: '' //截止时间
          }
        ]
      },
      formCheck: {
        year: '',
        selectedOptions: []
      },
      annualList: [
        { value: '上半年', label: '上半年' },
        { value: '下半年', label: '下半年' }
      ], //年度
      projectList: [], //项目列表
      contractList: [], //合同列表
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        annual: [{ required: true, message: '请选择年度', trigger: 'blur' }],
        projectId: [{ required: true, message: '请选择项目', trigger: 'blur' }],
        checkTime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        deadline: [
          { required: true, message: '请选择截止时间', trigger: 'blur' }
        ],
        contractId: [
          { required: true, message: '请选择合同', trigger: 'blur' }
        ],
        name: [{ required: true, message: '请输入轮次', trigger: 'blur' }]
      },
      rulesCheck: {
        year: [{ required: true, message: '请选择年份', trigger: 'blur' }]
      }
    }
  },
  watch: {
    'formData.roundsList': {
      handler(newValue) {
        console.log(newValue)
        this.formData.roundsList[0].checkTime = this.createDate
        let roundnum = newValue.length - 1
        this.formData.roundsList[roundnum].deadline = this.submitTime
        this.formData.roundsList[roundnum - 1].deadline = ''
      }
    }
  },
  created() {
    this.initYears()
  },
  methods: {
    // 获取项目列表
    getProjecitListFn() {
      let params = {}
      getProjecitList(params).then((res) => {
        this.projectList = res.data
      })
    },
    // 获取合同列表
    getContractListFn(projectId) {
      let params = { projectId }
      getContractList(params).then((res) => {
        this.contractList = res.data
      })
    },
    // 项目下拉
    proChange(proId) {
      console.log(proId, '项目')
      this.getContractListFn(proId)
      this.formData.contractId = ''
      this.createDate = ''
      this.submitTime = ''
      this.contractList = []
      this.chartList = []
    },
    // 合同下拉
    conChange(conId) {
      console.log(conId, '合同')
      if (conId) {
        this.findTimeFn(conId)
        this.findApplyStatusFn(conId)
        this.queryScoreByLevelThirdFn(conId)
        this.dangerousDeviceByTypeFn(conId)
      }
    },
    // 获取项目的开始/结束时间
    findTimeFn(contractId) {
      let params = { contractId }
      findTime(params).then((res) => {
        // this.contractList = res.data
        if (res.code == 200) {
          if (res.data) {
            if (res.data.createDate) {
              this.createDate = res.data.createDate
              this.formData.roundsList[0].checkTime = this.createDate
            }
            if (res.data.submitTime) {
              this.submitTime = res.data.submitTime
              let roundnum = this.formData.roundsList.length - 1
              this.formData.roundsList[roundnum].deadline = this.submitTime
            }
          }
        }
      })
    },
    // 判断合同下的检查单是否都提交了
    findApplyStatusFn(contractId) {
      let params = { contractId }
      findApplyStatus(params).then((res) => {
        console.log(res, '000000000')
        if (res.code == 200) {
          if (res.data && res.data != '') {
            this.$message({
              type: 'warning',
              message: res.data
            })
          }
        }
      })
    },
    // 新增轮次
    addFn() {
      this.formData.roundsList.push({
        // id: Date.now(),
        checkTime: '', //开始时间
        name: '', //第几轮次
        deadline: '' //截止时间
      })
    },
    //删除轮次
    deleteFn(item) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(item)
          // this.formData.roundsList = this.formData.roundsList.filter(
          //   (el) => el.id != item.id
          // )
          this.formData.roundsList.splice(item, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 获取图表数据接口  横向柱状
    queryScoreByLevelThirdFn(contractId) {
      let getRectificationTopData = {
        contractId
      }
      queryScoreByLevelThird(getRectificationTopData).then((res) => {
        console.log('横向柱状', res)
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            let datas = res.data
            datas.forEach((el, index) => {
              if (el) {
                el.checked = true
                el['chartId'] = index + 1
              }
            })
            this.chartList = this.chartList.concat(datas)
          }
        }
      })
    },
    //  获取图表数据接口  柱状
    dangerousDeviceByTypeFn(contractId) {
      let queryTestReportData = {
        contractId
      }
      dangerousDeviceByType(queryTestReportData).then((res) => {
        console.log('柱状', res)
        if (res.code == 200) {
          if (res.data) {
            let datas = res.data
            // datas.forEach((el, index) => {
            //   if (el) {
            datas.checked = true
            datas['chartId'] = this.chartList.length + 1
            //   }
            // })
            this.chartList.push(datas)
          }
        }
        // this.CheckRateList = res.data
        // let datas = res.data
        // if (datas.data && datas.data.length > 0) {
        //   datas.data.forEach((el) => {
        //     if (el.data && el.data.length > 0) {
        //       el.data = el.data.map((ele) => {
        //         return (ele * this.changeRatio).toFixed(1)
        //       })
        //     }
        //   })
        // }
        // this.CheckRateList = datas
      })
    },
    // base64图片转file文件
    base64ToFile(base64, fileName) {
      // 将base64文件流按照 , 分割前缀与后续内容
      let data = base64.split(',')
      // 获取文件格式（image/png、image/jpeg、image/webp等）
      let fileType = data[0].match(/:(.*?);/)[1]
      // 获取后缀（png、jpeg、webp）
      let suffix = fileType.split('/')[1]
      // 使用atob()对base64数据进行解码 返回文件数据流
      const bstr = window.atob(data[1])
      // 获取解码后  文件数据流的长度
      let n = bstr.length
      // 根据解码后数据流的长度创建一个等长的整形数字数组
      // 但在创建时 所有元素初始值都为 0
      const u8arr = new Uint8Array(n)
      // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
      while (n--) {
        // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
        u8arr[n] = bstr.charCodeAt(n)
      }
      // 创建File文件对象
      // new File(bits, name, options)
      const file = new File([u8arr], `${fileName}.${suffix}`, {
        type: fileType
      })
      // 将返回File文件对象
      return file
    },
    // 生成检查报告
    submitFn() {
      if (this.requestStatus) {
        // 利用 return 终止函数继续运行
        return false
      }
      console.log('按钮点击函数执行')
      // 执行函数
      this.requestStatus = true
      setTimeout(() => {
        // 模拟执行完毕
        // 改变 requestStatus
        this.requestStatus = false
      }, 1500)
      this.formData.pictureEntityList = []
      this.formData.pictureEntityListFirst = []

      this.$refs.formData.validate((valid) => {
        if (valid) {
          // 轮次数组添加项
          if (this.formData.roundsList && this.formData.roundsList.length > 0) {
            this.formData.roundsList.forEach((round, index) => {
              let num = index + 1
              round.name = '第' + num + '轮次'
            })
          }
          let selectArrs = [] //选择的图表数组
          selectArrs = this.chartList.filter((item) => item.checked == true)
          console.log(this.chartList, selectArrs, '数据---------')

          if (this.chartList.length > 0 && selectArrs.length == 0) {
            this.$message({
              message: '请选择图表',
              type: 'warning'
            })
            return
          }
          this.$loading({
            text: '报告生成中'
          })
          console.log(selectArrs, '选择的图表数组---------')
          // 有图表先上传图片再生成报告
          if (this.chartList.length > 0) {
            for (let i = 0; i < selectArrs.length; i++) {
              let canvas =
                this.$refs['chart' + selectArrs[i].chartId][0].pieMyChart
              let image = canvas.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: 'white'
              })
              console.log(`第${i + 1}个文件流`, image) //输出文件流，传输到后端接口的数据
              // base64图片转文件
              let file_ = this.base64ToFile(image, selectArrs[i].title)
              let fileData = new FormData() // new formData对象
              fileData.append('multipartFile', file_)
              // 上传图表图片
              uploadFile(fileData).then((res) => {
                if (res.code == 200) {
                  console.log(res.data, '返回的文件信息')
                  // 判断图表是什么类型
                  if (selectArrs[i].type == 'sortBar') {
                    let obj = {}
                    obj.width = 350
                    obj.height = 450
                    obj.path = res.data[0].uploadUrl
                    obj.deviceName = selectArrs[i].deviceName
                    obj.deviceType = selectArrs[i].deviceType
                    this.formData.pictureEntityList.push(obj) //横向柱状排序图
                  } else if (selectArrs[i].type == 'lineBar') {
                    let obj1 = {}
                    obj1.width = 400
                    obj1.height = 300
                    obj1.path = res.data[0].uploadUrl
                    this.formData.pictureEntityListFirst.push(obj1) //柱状排序图
                  }
                  // 判断是否请求完
                  if (
                    this.formData.pictureEntityList.length +
                      this.formData.pictureEntityListFirst.length ==
                    selectArrs.length
                  ) {
                    setTimeout(() => {
                      // 生成报告
                      genReports(this.formData).then((res) => {
                        if (res.code == 200) {
                          this.$loading().close()
                          saveAs(this.getImgUrl(res.data)) // 渲染到页面预览
                          console.log(this.getImgUrl(res.data), '生成报告')
                        }
                      })
                    }, 300)
                  }
                }
              })
            }
          } else {
            // 没有图表直接生成报告
            this.$loading().close()
            this.$message({
              message: '当前合同没有设备无法生成报告',
              type: 'error'
            })
          }
          console.log(this.formData, '表单数据0000000000000000')
        } else {
          console.log('error submit')
        }
      })
    },
    //设置日期列表
    initYears() {
      var myDate = new Date()
      var year = myDate.getFullYear() //获取当前年
      this.initSelectYear(year)
    },
    initSelectYear(year) {
      this.yearsList = []
      for (let i = 0; i < 30; i++) {
        this.yearsList.push({ value: year - i, label: year - i + '年' })
      }
    },
    queryScoreByYearFn(year) {
      console.log(year)
    },
    // 省市区
    handleChange(value) {
      console.log(value, '省市区')
      //value为省市区code数组
      var loc = ''

      if (value.length > 1) {
        //   this.addr = value.join('')
        //   console.log(this.formCheck.selectedOptions, '省市区')
        //   // this.form.selectedOptions = provinceCode + cityCode + orgion;
        // }
        for (let i = 0; i < value.length; i++) {
          if (value[i] != '') loc += CodeToText[value[i]]
        }
      } else if (value.length == 1) {
        loc = ''
      }
      this.addr = loc
    },
    // 生成检测报告
    checkReportFn() {
      // 防止重复点击
      if (this.requestCheckStatus) {
        // 利用 return 终止函数继续运行
        return false
      }
      console.log('按钮点击函数执行')
      // 执行函数
      this.requestCheckStatus = true
      setTimeout(() => {
        this.requestCheckStatus = false
      }, 1500)

      this.$refs.formCheck.validate((valid) => {
        if (valid) {
          this.$loading({
            text: '检测报告生成中'
          })
          let params = {
            year: this.formCheck.year,
            addr: this.addr
          }
          // 生成报告
          genCheckReports(params).then((res) => {
            if (res.code == 200) {
              saveAs(this.getImgUrl(res.data)) // 渲染到页面预览
            }
            setTimeout(() => {
              this.$loading().close()
            }, 1000)
          })
        }
      })
    }
  },
  mounted() {
    this.getProjecitListFn()
  }
}
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;
  justify-content: center;
  .form-button {
    width: 110px;
    margin: 0 20px;
  }
}
.boxList {
  width: 1600px;
  display: flex;
  flex-wrap: wrap;
}
.date-box {
  // margin-bottom: 20px;
  margin: 20px;
  width: 600px;
  height: 800px;
}
.data-chart {
  width: 600px;
  height: 800px;
  position: relative;
  box-shadow: 0 0 5px 1px #ccc;
  .el-select {
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    width: 30%;
  }
}
.data-chartline {
  width: 600px;
  height: 450px;
  position: relative;
  box-shadow: 0 0 5px 1px #ccc;
  .el-select {
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    width: 30%;
  }
}
.data-lang-box {
  padding: 10px 15px;
  box-sizing: border-box;
  .data-lang-title {
    line-height: 32px;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  .data-lang-item {
    height: 48px;
    line-height: 20px;
  }
}
.putOnRecord {
  position: relative;
  font-size: 12px;
  color: #000;
  margin-bottom: 20px;
  padding: 10px 20px;
  margin-left: 10px;
  background: #fafafa;
  .putOnRecord_p {
    display: flex;

    flex-direction: column;
    .stepNumber {
      display: flex;
      color: #409eff;
      font-size: 14px;
      justify-content: center;
      align-items: center;
    }
    p {
      padding: 0;
      line-height: 58px;
      // height: 58px;
    }
  }
}
</style>
